import { FC, Fragment, memo } from "react"
import { GripVertical } from "lucide-react"

import { formatAsTwoDigits } from "../../../utils"
import { PricingSet } from "../../../../types"
import If from "../../if"

type Props = {
  pricingSet?: PricingSet
  maxItems?: number
  onClick: (id: string) => void
}

const LoanProgramCardHeader: FC<Props> = memo(
  ({ pricingSet, maxItems = 5, onClick }) => {
    const handleClick = () => {
      onClick(pricingSet!.id)
    }

    const pricingSetClickHandler = pricingSet?.id ? handleClick : undefined

    return (
      <div
        className="border rounded-lg divide-y divide-gray-200 min-h-[224px] cursor-pointer"
        onClick={pricingSetClickHandler}
      >
        <If
          condition={!!pricingSet?.pricing_profiles?.length}
          then={
            <Fragment>
              {pricingSet!
                .pricing_profiles!.slice(0, maxItems)
                .map((profile, index) => (
                  <div key={index} className="flex items-center py-2">
                    <div className="flex items-center">
                      <GripVertical size={12} className="text-neutral-400" />
                      <div className="text-sm font-inter-extrabold ml-1">
                        {formatAsTwoDigits(index + 1)}
                      </div>
                    </div>
                    <div className="text-xs pl-4">{profile.title ?? ""}</div>
                  </div>
                ))}
            </Fragment>
          }
        />
      </div>
    )
  }
)

export default LoanProgramCardHeader
